/*
 * Actions pour les compétences génériques
 */

export const FETCH_COMPETENCES_GENERIQUES_REQUEST = "FETCH_COMPETENCES_GENERIQUES_REQUEST";
export const FETCH_COMPETENCES_GENERIQUES_SUCCESS = "FETCH_COMPETENCES_GENERIQUES_SUCCESS";
export const FETCH_COMPETENCES_GENERIQUES_FAIL    = "FETCH_COMPETENCES_GENERIQUES_FAIL";

export const CREATE_COMPETENCE_GENERIQUE_REQUEST = "CREATE_COMPETENCE_GENERIQUE_REQUEST";
export const CREATE_COMPETENCE_GENERIQUE_SUCCESS = "CREATE_COMPETENCE_GENERIQUE_SUCCESS";
export const CREATE_COMPETENCE_GENERIQUE_FAIL    = "CREATE_COMPETENCE_GENERIQUE_FAIL";

export const UPDATE_COMPETENCE_GENERIQUE_REQUEST = "UPDATE_COMPETENCE_GENERIQUE_REQUEST";
export const UPDATE_COMPETENCE_GENERIQUE_SUCCESS = "UPDATE_COMPETENCE_GENERIQUE_SUCCESS";
export const UPDATE_COMPETENCE_GENERIQUE_FAIL    = "UPDATE_COMPETENCE_GENERIQUE_FAIL";

export const DELETE_COMPETENCE_GENERIQUE_REQUEST = "DELETE_COMPETENCE_GENERIQUE_REQUEST";
export const DELETE_COMPETENCE_GENERIQUE_SUCCESS = "DELETE_COMPETENCE_GENERIQUE_SUCCESS";
export const DELETE_COMPETENCE_GENERIQUE_FAIL    = "DELETE_COMPETENCE_GENERIQUE_FAIL";

export const SET_COMPETENCES_GENERIQUES_LOADING = "SET_COMPETENCES_GENERIQUES_LOADING";

// Creators
export const fetchCompetencesGeneriquesRequest = () => ({ type: FETCH_COMPETENCES_GENERIQUES_REQUEST });
export const fetchCompetencesGeneriquesSuccess = (data) => ({ type: FETCH_COMPETENCES_GENERIQUES_SUCCESS, payload: data });
export const fetchCompetencesGeneriquesFail    = (msg) => ({ type: FETCH_COMPETENCES_GENERIQUES_FAIL, payload: msg });

export const createCompetenceGeneriqueRequest = (payload) => ({ type: CREATE_COMPETENCE_GENERIQUE_REQUEST, payload });
export const createCompetenceGeneriqueSuccess = (data) => ({ type: CREATE_COMPETENCE_GENERIQUE_SUCCESS, payload: data });
export const createCompetenceGeneriqueFail    = (msg) => ({ type: CREATE_COMPETENCE_GENERIQUE_FAIL, payload: msg });

export const updateCompetenceGeneriqueRequest = (id, payload) => ({ type: UPDATE_COMPETENCE_GENERIQUE_REQUEST, payload: { id, payload } });
export const updateCompetenceGeneriqueSuccess = (data) => ({ type: UPDATE_COMPETENCE_GENERIQUE_SUCCESS, payload: data });
export const updateCompetenceGeneriqueFail    = (msg) => ({ type: UPDATE_COMPETENCE_GENERIQUE_FAIL, payload: msg });

export const deleteCompetenceGeneriqueRequest = (id) => ({ type: DELETE_COMPETENCE_GENERIQUE_REQUEST, payload: { id } });
export const deleteCompetenceGeneriqueSuccess = (id) => ({ type: DELETE_COMPETENCE_GENERIQUE_SUCCESS, payload: { id } });
export const deleteCompetenceGeneriqueFail    = (msg) => ({ type: DELETE_COMPETENCE_GENERIQUE_FAIL, payload: msg });

export const setCompetencesGeneriquesLoading = (loading) => ({ type: SET_COMPETENCES_GENERIQUES_LOADING, payload: loading });
